/** Legal suffixes stripped from the end of a brand name before comparison. */
const LEGAL_SUFFIXES = ['inc', 'llc', 'co', 'ltd'];

/** Casefold, trim, strip punctuation, strip legal suffixes/leading "the" for brand-name comparison. */
export function normalizeBountyCompanyName(name: string): string {
  let normalized = name.trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
  normalized = normalized.replace(/^the\s+/, '');
  const words = normalized.split(' ');
  if (words.length > 1 && LEGAL_SUFFIXES.includes(words[words.length - 1])) {
    words.pop();
  }
  return words.join(' ').trim();
}

export const normalizeInstagramHandle = (handle: string): string =>
  handle.trim().replace(/^@+/, '').toLowerCase();
